import dayjs from 'dayjs'
import { Flex } from '@chakra-ui/react'
import { Button } from '@/components/ui/button'
import { useTranslations } from 'next-intl'

const DateSelector = ({
  value,
  onDateSelect,
}: {
  value: dayjs.Dayjs
  onDateSelect: (e: dayjs.Dayjs) => void
}) => {
  const t = useTranslations()

  // Generate array of next 30 days (you can adjust this number)
  const dates = Array.from({ length: 30 }, (_, i) => {
    return dayjs().add(i, 'day')
  })

  const handleDateSelect = (date: dayjs.Dayjs) => {
    onDateSelect(date)
  }

  const isToday = (date: dayjs.Dayjs) => date.isSame(dayjs(), 'day')
  const isTomorrow = (date: dayjs.Dayjs) =>
    date.isSame(dayjs().add(1, 'day'), 'day')
  const isSelected = (date: dayjs.Dayjs) => date.isSame(value, 'day')

  return (
    <Flex py={4} gap={2} overflowX='auto'>
      {dates.map((date) => (
        <Button
          key={date.format('YYYY-MM-DD')}
          onClick={() => handleDateSelect(date)}
          {...(isSelected(date)
            ? {
                variant: 'solid',
                bgColor: 'primary',
                color: 'primary.text',
              }
            : {
                variant: 'subtle',
              })}
        >
          {isToday(date) ? (
            <p className='font-medium'>{t('today')}</p>
          ) : isTomorrow(date) ? (
            <p className='font-medium'>{t('tomorrow')}</p>
          ) : (
            <>
              <p className='text-sm text-gray-600'>{date.format('dd')}</p>
              <p className='text-lg font-medium'>{date.format('DD')}</p>
            </>
          )}
        </Button>
      ))}
    </Flex>
  )
}

export default DateSelector
